import { IDictionaryService } from "../../services/dictionary/IDictionaryService";
import { Word } from "../word/Word";
import { DictionaryDefinition } from "./DictionaryDefinition";

export class DictionaryStore {
  constructor(private service: IDictionaryService) {}

  getDefinition(
    word: Word,
    callback: (definition: DictionaryDefinition) => void
  ) {
    if (!word) {
      throw new Error("word is not set");
    }

    if (word.hasDefinition()) {
      callback(word.definition);
      return;
    }

    this.service.getDefinition(word, callback);
  }
}



// WEBPACK FOOTER //
// ./stores/dictionary/DictionaryStore.ts